import React, { Dispatch, PropsWithChildren, SetStateAction, useState } from 'react';
import { PAGES } from '../../../types/enums/pages.enum';

export type PagesContextType = {
    value : PAGES;
    set: Dispatch<SetStateAction<PAGES>>
}

export const PagesContext = React.createContext<PagesContextType | null>(null);

const PagesContextProvider = ({children} : PropsWithChildren) => {
    const [page, setPage] = useState<PAGES>(PAGES.SELECTION);

    const pageContextValue : PagesContextType = {
        value: page,
        set: setPage
    }

    return (
            <PagesContext.Provider value={pageContextValue}>
                {children}
            </PagesContext.Provider>
    );
}

export default PagesContextProvider;
